import React, { CSSProperties } from 'react';
import { BeatLoader, ClipLoader, GridLoader } from 'react-spinners';

export interface ComponentProps {
  size?: number;
  margin?: number;
  color?: string;
  loading: boolean;
  className?: string;
  speed?: number;
  type?: 'grid' | 'beat' | 'clip';
  style?: CSSProperties;
  dataCy?: string;
}

const Spinner: React.FC<ComponentProps> = ({
  type = 'grid',
  size = 20,
  className = '',
  speed = 1,
  style,
  dataCy = 'loading-spinner',
  ...props
}) => {
  let loader;
  switch (type) {
    case 'clip': {
      loader = <ClipLoader size={size} speedMultiplier={speed} {...props} data-cy={dataCy} />;
      break;
    }
    case 'beat': {
      loader = <BeatLoader size={size} speedMultiplier={speed} {...props} data-cy={dataCy} />;
      break;
    }
    case 'grid':
    default: {
      loader = <GridLoader size={size} speedMultiplier={speed} {...props} data-cy={dataCy} />;
      break;
    }
  }

  return (
    <div className={`spinner d-flex justify-content-center ${className}`} style={style} data-cy={dataCy}>
      {loader}
    </div>
  );
};

export default Spinner;
